import { render } from "./mainLayout.vue?vue&type=template&id=7d9869c4&ts=true"
import script from "./mainLayout.vue?vue&type=script&lang=ts"
export * from "./mainLayout.vue?vue&type=script&lang=ts"

import "./mainLayout.vue?vue&type=style&index=0&id=7d9869c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__